import React, {isValidElement, useEffect, useState} from 'react';
import TextInput from '../../UI/Form/TextInput';
import SelectDropDown from '../../UI/Form/SelectDropDown';
import {getAllUsers} from '../../Actions/getUsers';
import SaveButton from '../../Component/SaveButton';
import SecondaryButton from '../../Component/SecondryButton';
import {onUserSubmit} from './Actions/OnUserSubmit';
import SelectAndSearchDropDown from '../../UI/Form/SelectAndSearchDropDown';

const UserSelection = ({
  current_step,
  setCurrentStep,
  isLoading,
  setIsLoading,
  setSelectedUser,
  fullCartInfo,
  setFullCartInfo,
}) => {
  const [is_set_new_user, setIsSetNewUser] = useState(false);
  //  "user": {
  const [form_state, setFormState] = useState({
    is_user_selected: false,
    user_id: '',
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    type: 'customer',
  });

  const [users, setUsers] = useState([]);

  useEffect(() => {
    getAllUsers({}).then(res => {
      setUsers(res);
    });
  }, []);

  // is ready for next
  const isReadyForNext = () => {
    return (
      form_state?.is_user_selected ||
      (isValidElement(form_state?.email) &&
        form_state?.first_name &&
        form_state?.last_name)
    );
  };

  useEffect(() => {
    if (form_state?.email && form_state?.first_name && form_state?.last_name) {
      onUserSubmit({
        form_state,
        setFormState,
        setIsLoading,
        setCurrentStep,
        setSelectedUser,
        setFullCartInfo,
      });
    }
  }, [form_state]);

  return (
    <div className=" flex-none flex flex-col gap-3   h-full   border border-gray-200 rounded-md py-4 px-5  w-[95%]   m-3 mx-auto">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-bold">User </h1>
        <button
          className=" px-4  rounded-md text-base hover:text-primary"
          onClick={() => setIsSetNewUser(!is_set_new_user)}>
          {!is_set_new_user ? 'Add New User' : 'Add Existing User'}
        </button>
      </div>
      {!is_set_new_user ? (
        <SelectAndSearchDropDown
          name={'users'}
          selected_value={
            form_state?.is_user_selected
              ? {
                  label: `${form_state?.first_name} (${form_state?.email})`,
                  value: form_state?.user_id,
                }
              : null
          }
          setSelectedValue={item => {
            const selected_user = users?.find(c => c.id === item.value);
            if (selected_user) {
              setFormState({
                ...form_state,
                is_user_selected: true,
                user_id: selected_user?.id,
                email: selected_user?.email,
                first_name: selected_user?.first_name,
                last_name: selected_user?.last_name,
              });
            }
          }}
          list={
            users?.map(c => ({
              label: `${c.first_name} (${c.email})`,
              value: c.id,
            })) || []
          }
          default_text={'Select user'}
        />
      ) : (
        <div className="flex flex-col gap-3">
          <TextInput
            title={'Email'}
            current_data={form_state?.email}
            placeholder={'Email'}
            type={'text'}
            update_data={data => setFormState({...form_state, email: data})}
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />

          {/* First Name */}
          <TextInput
            title={'First Name'}
            current_data={form_state?.first_name}
            placeholder={'First Name'}
            type={'text'}
            update_data={data =>
              setFormState({...form_state, first_name: data})
            }
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />

          {/* Last Name */}
          <TextInput
            title={'Last Name'}
            current_data={form_state?.last_name}
            placeholder={'Last Name'}
            type={'text'}
            update_data={data => setFormState({...form_state, last_name: data})}
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />
        </div>
      )}
    </div>
  );
};

export default UserSelection;
